import "@/components/QuotaProgressBar/quota.css";
import type { AppPropsWithLayout, AppShellProps } from "@/components/app-shell/types";
import { logger } from "@/lib/logger";
import "@/styles/quill-theme.css";
import { isPublicAuthPath } from "@/utils/authRoutes";
import { createStaticRouter } from "@/utils/staticRouter";
// Global CSS imports
import "@xyflow/react/dist/style.css";
import "allotment/dist/style.css";
import "katex/dist/katex.min.css";
import { appWithTranslation } from "next-i18next";
import { useRouter } from "next/compat/router";
import dynamic from "next/dynamic";
import "nprogress/nprogress.css";
import "quill/dist/quill.snow.css";

import "./styles.css";

const STATIC_ROUTER = createStaticRouter();

const PublicAuthAppShell = dynamic<AppShellProps>(() => import("@/components/app-shell/PublicAuthAppShell"), {
  ssr: true
});
const ProtectedAppShell = dynamic<AppShellProps>(() => import("@/components/app-shell/ProtectedAppShell"), {
  ssr: true
});

function App(props: AppPropsWithLayout) {
  const actualRouter = useRouter();
  const router = actualRouter ?? STATIC_ROUTER;
  const AppShell = isPublicAuthPath(router.pathname) ? PublicAuthAppShell : ProtectedAppShell;

  return <AppShell {...props} />;
}

export function reportWebVitals(metric: any) {
  if (process.env.NODE_ENV === "development") {
    logger.info("[Web Vitals]", metric);
  }
}

export default appWithTranslation(App);
